import React, { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { ButtonV2 } from 'components/common/ui';
import { Box } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import { showError } from '@utils';
import { isEmpty } from 'lodash-es';

import { Consumer } from './Consumer';
import { Business } from './Business';

import validationSchema from './creditScoreFormValidationSchema';

import styles from './creditScoreForm.style';

const CreditScoreForm = ({ defaultValues, loading, onSubmit }) => {
  const resolver = yupResolver(validationSchema);
  const methods = useForm({
    resolver,
    defaultValues,
  });

  useEffect(() => {
    if (defaultValues) {
      methods.reset(defaultValues);
    }
  }, [defaultValues, methods]);

  useEffect(() => {
    if (!isEmpty(methods.formState.errors)) {
      showError('Score not created, data missing.');
    }
  }, [methods.formState.errors]);

  return (
    <FormProvider {...methods}>
      <Box sx={styles.saveButtonWrapper}>
        <ButtonV2
          type="submit"
          form="credit-score-form"
          loading={loading}
          size="small"
        >
          Save
        </ButtonV2>
      </Box>
      <form id="credit-score-form" onSubmit={methods.handleSubmit(onSubmit)}>
        <Consumer loading={loading} methods={methods} />
        <Business loading={loading} methods={methods} />
      </form>
    </FormProvider>
  );
};

const memoizedCreditScoreForm = React.memo(CreditScoreForm);
export { memoizedCreditScoreForm as CreditScoreForm };

export default memoizedCreditScoreForm;
